import { RootState } from "src/store/store";

/**
 * 
 */
export namespace PolicyDriverDataSelector {

  export const storedDriver = (state: RootState) => state.driverData?.storedDriver;
}
